import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import { useTranslation } from "react-i18next";

function ExteriorSpacesPage() {
    const { t } = useTranslation();
    const directory= "/images/exoterikoiHoroi/";
    const filenames=[
        'VPR02490_Vasso_Paraschi.webp',
        'VPR02493_Vasso_Paraschi.webp',
        'VPR02670_Vasso_Paraschi.webp',
        'VPR02672_Vasso_Paraschi.webp',
        'VPR02891_Vasso_Paraschi.webp',
        'VPR03286_Vasso_Paraschi.webp',
        'VPR03292_Vasso_Paraschi.webp',
        'VPR03307_Vasso_Paraschi.webp',
        'VPR03314_Vasso_Paraschi.webp',
        'VPR03322_Vasso_Paraschi.webp',
        'VPR03482_Vasso_Paraschi.webp',
        'VPR03554_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Exterior Spaces")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default ExteriorSpacesPage;
